<div id="template-container">
    <app-section-banner [bannerContent]="bannerContent"></app-section-banner>
    <div class="template-background">
        <app-column-text-viewer [rows]="textRows"></app-column-text-viewer>
    </div>
    <div class="template-hero-container">
    <app-solutions-card [solution]="solution"></app-solutions-card>
    </div>


</div>
